import { forwardRef, useMemo } from 'react';

import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';

import { theme } from '@styles/theme';
import { resolveCssColor } from '@utils/browser';

import { buildJourneysMarkDataUrl } from './journeys-mark';

const QR_SIZE = 136;
const QR_LOGO_SIZE = 40;

export type QrCodeProps = {
  value: string;
  label: string;
  size?: number;
};

export const QrCode = forwardRef<HTMLDivElement, QrCodeProps>(
  ({ value, label, size = QR_SIZE }, ref) => {
    const qrCode = useMemo(() => {
      const markColor = resolveCssColor(theme.color.indigo400);
      const logoBackgroundColor = resolveCssColor(theme.color.indigo5);
      return (
        <QRCodeSVG
          value={value}
          size={size}
          level="H"
          fgColor={markColor}
          role="img"
          aria-label={label}
          includeMargin
          imageSettings={{
            src: buildJourneysMarkDataUrl(markColor, logoBackgroundColor),
            height: QR_LOGO_SIZE,
            width: QR_LOGO_SIZE,
            excavate: true,
          }}
        />
      );
    }, [value, label, size]);

    return <QrTile ref={ref}>{qrCode}</QrTile>;
  },
);

export const getQrCodeSvg = (container: HTMLDivElement | null) => {
  if (!container) {
    return null;
  }
  return container.querySelector('svg');
};

const QrTile = styled.div({
  display: 'flex',
  background: theme.color.white100,
  flexShrink: 0,
});
